module.exports = __webpack_public_path__ + "assets/img/cicon.edaeab61.svg";